<ng-container *ngIf="responsableData | async as r; else fallback">
  <div class="w-full rounded-2xl shadow-sm">
    <div class="grid grid-cols-2 text-gray-700 dark:text-gray-300">
      <p>
        <strong>Indication: </strong>
        <span class="thin" [class.opacity-70]="!r.indication?.trim()">
          {{ r.indication?.trim() ? r.indication : 'Non précisé' }}
        </span>
      </p>
      <p>
        <strong>Nom complet: </strong>
        <span class="thin" [class.opacity-70]="!(r.firstName?.trim() && r.lastName?.trim())">
          {{ (r.firstName?.trim() && r.lastName?.trim()) ? r.firstName + ' ' + r.lastName : 'Non précisé' }}
        </span>
      </p>

      <p>
        <strong>Email: </strong>
        <span class="thin" [class.opacity-70]="!r.email?.trim()">
          {{ r.email?.trim() ? r.email : 'Non précisé' }}
        </span>
      </p>

      <p>
        <strong class="font-bold">Téléphone: </strong>
        <span class="thin" [class.opacity-70]="!r.tel?.trim()">
          {{ r.tel?.trim() ? r.tel : 'Non précisé' }}
        </span>
      </p>

      <p>
        <strong class="font-bold">Adresse: </strong>
        <span class="thin" [class.opacity-70]="!r.adresse?.trim()">
          {{ r.adresse?.trim() ? r.adresse : 'Non précisé' }}
        </span>
      </p>


    </div>
    <hr class="mt-1" />
  </div>
</ng-container>

<ng-template #fallback>
  <div
    class="w-full max-w-md mx-auto p-4 rounded-2xl shadow-sm bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700">
    <h1 class="text-xl font-semibold mb-3 text-gray-900 dark:text-gray-100">Responsable</h1>
    <p class="text-sm italic opacity-70 text-gray-600 dark:text-gray-400">Non précisé</p>
  </div>
</ng-template>